// packages/ag-charts-locale/src/tr-TR.ts
var AG_CHARTS_LOCALE_TR_TR = {
  ariaAnnounceChart: "grafik, ${seriesCount}[number] seri",
  ariaAnnounceFlowProportionLink: "ba\u011Flant\u0131 ${index} / ${count}, ${from} - ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "d\xFC\u011F\xFCm ${index} / ${count}, ${description}",
  ariaAnnounceGaugeChart: "g\xF6sterge grafik, ${caption}",
  ariaAnnounceHierarchyChart: "hiyerar\u015Fi grafi\u011Fi, ${caption}",
  ariaAnnounceHierarchyDatum: "seviye ${level}[number], ${count}[number] \xE7ocuk, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "G\xF6r\xFCn\xFCrl\xFC\u011F\xFC de\u011Fi\u015Ftirmek i\xE7in Bo\u015Fluk veya Enter tu\u015Funa bas\u0131n",
  ariaLabelAddHorizontalLine: "Yatay \xC7izgi Ekle",
  ariaLabelAnnotationOptionsToolbar: "Ek A\xE7\u0131klama Se\xE7enekleri",
  ariaLabelAnnotationSettingsDialog: "Ek A\xE7\u0131klama Ayarlar\u0131",
  ariaLabelColorPicker: "Renk se\xE7ici",
  ariaLabelFinancialCharts: "Finansal Grafikler",
  ariaLabelLegend: "Efsane",
  ariaLabelLegendItem: "${label}, Lejant \xF6\u011Fesi ${index}[number] of ${count}[number]",
  ariaLabelLegendItemUnknown: "Bilinmeyen efsane \xF6\u011Fesi",
  ariaLabelLegendPageNext: "Sonraki Efsane Sayfas\u0131",
  ariaLabelLegendPagePrevious: "\xD6nceki Efsane Sayfas\u0131",
  ariaLabelLegendPagination: "Efsane Sayfalama",
  ariaLabelNavigator: "Gezgin",
  ariaLabelNavigatorMaximum: "Maksimum",
  ariaLabelNavigatorMinimum: "Minimum",
  ariaLabelNavigatorRange: "Aral\u0131k",
  ariaLabelRangesToolbar: "Aral\u0131klar",
  ariaLabelSettingsTabBar: "Ayarlar",
  ariaLabelZoomToolbar: "Yak\u0131nla\u015Ft\u0131r",
  ariaValuePanRange: "${min}[percent0to2dp] ile ${max}[percent0to2dp] aras\u0131",
  contextMenuDownload: "\u0130ndir",
  contextMenuPanToCursor: "Buraya kayd\u0131r",
  contextMenuToggleOtherSeries: "Di\u011Fer Serileri De\u011Fi\u015Ftir",
  contextMenuToggleSeriesVisibility: "G\xF6r\xFCn\xFCrl\xFC\u011F\xFC De\u011Fi\u015Ftir",
  contextMenuZoomToCursor: "Buraya yak\u0131nla\u015Ft\u0131r",
  dialogHeaderChannel: "Kanal",
  dialogHeaderDatePriceRange: "Tarih ve Fiyat",
  dialogHeaderDateRange: "Tarih Aral\u0131\u011F\u0131",
  dialogHeaderFibonacciRange: "Fib Geri \xC7ekilme",
  dialogHeaderLine: "\xC7izgi",
  dialogHeaderPriceRange: "Fiyat Aral\u0131\u011F\u0131",
  dialogHeaderText: "Metin",
  dialogInputAlign: "Hizala",
  dialogInputColorPicker: "Renk",
  dialogInputColorPickerAltText: "Metin Rengi",
  dialogInputExtendAbove: "\xDCst\xFCne geni\u015Flet",
  dialogInputExtendBelow: "A\u015Fa\u011F\u0131ya geni\u015Flet",
  dialogInputExtendChannelEnd: "Kanal sonunu uzat",
  dialogInputExtendChannelStart: "Kanal ba\u015Flang\u0131c\u0131n\u0131 uzat",
  dialogInputExtendLeft: "Sola uzat",
  dialogInputExtendLineEnd: "\xC7izgi ucunu uzat",
  dialogInputExtendLineStart: "\xC7izgi ba\u015Flang\u0131c\u0131n\u0131 uzat",
  dialogInputExtendRight: "Sa\u011Fa geni\u015Flet",
  dialogInputFibonacciBands: "Bantlar",
  dialogInputFibonacciBandsAltText: "Fibonacci Bantlar\u0131",
  dialogInputFillColorPicker: "Doldur",
  dialogInputFillColorPickerAltText: "Doldurma Rengi",
  dialogInputFontSize: "Yaz\u0131 tipi boyutu",
  dialogInputFontSizeAltText: "Yaz\u0131 Boyutu",
  dialogInputLineStyle: "Tire",
  dialogInputPosition: "Konum",
  dialogInputReverse: "Ters \xC7evir",
  dialogInputShowFill: "Dolguyu G\xF6ster",
  dialogInputStrokeWidth: "\xC7izgi Kal\u0131nl\u0131\u011F\u0131",
  dialogInputStrokeWidthAltText: "\xC7izgi A\u011F\u0131rl\u0131\u011F\u0131",
  iconAltTextAlignCenter: "Ortala",
  iconAltTextAlignLeft: "Sola",
  iconAltTextAlignRight: "Sa\u011Fa",
  iconAltTextClose: "Kapat",
  iconAltTextLineStyleDashed: "Uzun tireli",
  iconAltTextLineStyleDotted: "K\u0131sa \xE7izgili",
  iconAltTextLineStyleSolid: "D\xFCz",
  iconAltTextPositionBottom: "Alt",
  iconAltTextPositionCenter: "Merkez",
  iconAltTextPositionTop: "\xDCst",
  inputTextareaPlaceholder: "Metin Ekle",
  measurerDateRangeBars: "${value}[number] \xE7ubuk",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "Hacim ${value}",
  overlayLoadingData: "Veriler y\xFCkleniyor...",
  overlayNoData: "G\xF6sterilecek veri yok",
  overlayNoVisibleSeries: "G\xF6r\xFCnen seri yok",
  overlayUnsupportedBrowser: "Uyumsuz taray\u0131c\u0131 s\xFCr\xFCm\xFC. L\xFCtfen taray\u0131c\u0131n\u0131z\u0131 y\xFCkseltin.",
  seriesHistogramTooltipCount: "${yName} (say\u0131m)",
  seriesHistogramTooltipFrequency: "Frekans",
  seriesHistogramTooltipMean: "${yName} (ortalama)",
  seriesHistogramTooltipSum: "${yName} (toplam)",
  toolbarAnnotationsArrow: "Ok",
  toolbarAnnotationsArrowDown: "A\u015Fa\u011F\u0131 Ok",
  toolbarAnnotationsArrowUp: "Yukar\u0131 Ok",
  toolbarAnnotationsCallout: "Balon",
  toolbarAnnotationsClearAll: "Hepsini Temizle",
  toolbarAnnotationsComment: "Yorum",
  toolbarAnnotationsDatePriceRange: "Tarih ve Fiyat",
  toolbarAnnotationsDateRange: "Tarih Aral\u0131\u011F\u0131",
  toolbarAnnotationsDelete: "Sil",
  toolbarAnnotationsDisjointChannel: "Ayr\u0131k Kanal",
  toolbarAnnotationsDragHandle: "Ara\xE7 \xC7ubu\u011Funu S\xFCr\xFCkle",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Fib D\xFCzeltme",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Fib Trend Tabanl\u0131",
  toolbarAnnotationsFillColor: "Doldurma Rengi",
  toolbarAnnotationsHorizontalLine: "Yatay \xC7izgi",
  toolbarAnnotationsLineAnnotations: "Trend \xC7izgileri",
  toolbarAnnotationsLineColor: "\xC7izgi Rengi",
  toolbarAnnotationsLineStrokeWidth: "\xC7izgi Kal\u0131nl\u0131\u011F\u0131",
  toolbarAnnotationsLineStyle: "\xC7izgi Stili",
  toolbarAnnotationsLock: "Kilitle",
  toolbarAnnotationsMeasurerAnnotations: "\xD6l\xE7\xFCmc\xFCler",
  toolbarAnnotationsNote: "Not",
  toolbarAnnotationsParallelChannel: "Paralel Kanal",
  toolbarAnnotationsPriceRange: "Fiyat Aral\u0131\u011F\u0131",
  toolbarAnnotationsQuickDatePriceRange: "\xD6l\xE7\xFC",
  toolbarAnnotationsSettings: "Ayarlar",
  toolbarAnnotationsShapeAnnotations: "Oklar",
  toolbarAnnotationsText: "Metin",
  toolbarAnnotationsTextAnnotations: "Metin A\xE7\u0131klamalar\u0131",
  toolbarAnnotationsTextColor: "Metin Rengi",
  toolbarAnnotationsTextSize: "Yaz\u0131 Boyutu",
  toolbarAnnotationsTrendLine: "Trend \xC7izgisi",
  toolbarAnnotationsUnlock: "Kilidi A\xE7",
  toolbarAnnotationsVerticalLine: "Dikey \xC7izgi",
  toolbarRange1Month: "1A",
  toolbarRange1MonthAria: "1 ay",
  toolbarRange1Year: "1Y",
  toolbarRange1YearAria: "1 y\u0131l",
  toolbarRange3Months: "3A",
  toolbarRange3MonthsAria: "3 ay",
  toolbarRange6Months: "6A",
  toolbarRange6MonthsAria: "6 ay",
  toolbarRangeAll: "T\xFCm\xFC",
  toolbarRangeAllAria: "T\xFCm\xFC",
  toolbarRangeYearToDate: "YTD'ye Kadar",
  toolbarRangeYearToDateAria: "Y\u0131l ba\u015F\u0131ndan bu yana",
  toolbarSeriesTypeCandles: "Mumlar",
  toolbarSeriesTypeDropdown: "Grafik T\xFCr\xFC",
  toolbarSeriesTypeHighLow: "Y\xFCksek D\xFC\u015F\xFCk",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "Bo\u015F Mumlar",
  toolbarSeriesTypeLine: "\xC7izgi",
  toolbarSeriesTypeLineWithMarkers: "\u0130\u015Faretlerle \xC7izgi",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "Basamak \xC7izgisi",
  toolbarZoomPanEnd: "En sona kayd\u0131r",
  toolbarZoomPanLeft: "Sola kayd\u0131r",
  toolbarZoomPanRight: "Sa\u011Fa kayd\u0131r",
  toolbarZoomPanStart: "Ba\u015Flang\u0131ca kayd\u0131r",
  toolbarZoomReset: "Yak\u0131nla\u015Ft\u0131rmay\u0131 s\u0131f\u0131rla",
  toolbarZoomZoomIn: "Yak\u0131nla\u015Ft\u0131r",
  toolbarZoomZoomOut: "Uzakla\u015Ft\u0131r",
  tooltipPaginationStatus: "${index}[number] / ${count}[number]"
};
export {
  AG_CHARTS_LOCALE_TR_TR
};
//# sourceMappingURL=tr-TR.esm.mjs.map
